export default {

  "home": {
    "deviceSum": "Общее количество устройств",
    "onlineDevice": "Устройства в сети",
    "alarmQuantity": "Количество тревог",
    "offDevice": "Оффлайн-устройства",
    "deviceList": "Список устройств",
    "map": "Информация на карте",
    "deviceInfo": "Информация об устройстве",
    "deviceName": "Название устройства",
    "groupId": "Идентификатор группы",
    "onlineState": "Состояние подключения",
    "deviceOffTime": "Время отключения",
    "deviceOnlineTime": "Время подключения",
    "createTime": "Время создания",
    "featureInfo": "Информация об особенностях",
    "noData": "Нет данных",
    "groupNoDevice": "В текущей группе нет устройств",
    "offLine": "Оффлайн",
    "onLine": "Онлайн"
  },
  "arg": {
    "closeDialog": "Вы уверены, что хотите закрыть?",
    "viewCurve": "Просмотреть график",
    "historicalData": "Исторические данные",
    "query": "Поиск",
    "exportData": "Экспорт данных",
    "noTime": "Время начала и окончания не может быть пустым",
    'noTimeRange': 'Слишком длинный временной интервал',
    'noAtr': 'Атрибут не может быть пустым'
  },
  "group": {
    "defaultGroup": "Группа по умолчанию",
    "groupList": "Список сцен",
    "inputGroupName": "Пожалуйста, введите название сцены",
    "selectGroupState": "Пожалуйста, выберите статус сцены",
    "inputDeviceName": "Пожалуйста, введите название устройства",
    "editSuccess": "Успешное редактирование",
    "editFail": "Не удалось отредактировать",
    "confirmSubmission": "Вы уверены, что хотите отправить?",
    "tip": "Подсказка",
    "confirm": "Подтвердить",
    "cancel": "Отмена",
    "addSuccess": "Успешно добавлено",
    "addFail": "Не удалось добавить",
    "sureDeleteScene": "Вы уверены, что хотите удалить текущую сцену?",
    "successDelete": "Успешно удалено",
    "undelete": "Отмена удаления",
    "search": "Поиск",
    "newScene": "Создать новую сцену",
    "edit": "Редактировать",
    "sceneName": "Название сцены",
    "sceneState": "Статус сцены",
    "usable": "Доступно",
    "forbidden": "Отключено",
    "submit": "Отправить"
  },
  "device": {
    "noteNameTip": "Пожалуйста, введите имя примечания",
    "noteName": "Имя примечания",
    "devicename": "Название устройства",
    "homeGroup": "Принадлежит группе",
    "longitude": "Долгота",
    "latitude": "Широта",
    "deviceNameSearch": "Пожалуйста, введите название устройства для поиска",
    "equipmentInformation": "Информация об устройстве",
    "ProductOwnership": "Принадлежность продукта",
    "creationTime": "Время создания",
    "operation": "Операции"
  },
  "alarm": {
    "runningStatus": "Состояние работы",
    "close": "Остановить",
    "open": "В работе",
    "handleOpen": "Запустить",
    "passageway": "Канал уведомления",
    "selectPassageway": "Пожалуйста, выберите канал уведомления",
    "alarmRule": "Правило тревоги",
    "searchTitle": "Пожалуйста, введите заголовок тревоги для поиска",
    "add": "Добавить",
    "edit": "Редактировать",
    "triggerType": "Тип триггера",
    "attributeChange": "Изменение свойства устройства",
    "deviceOffLine": "Устройство офлайн",
    "hitCount": "Количество срабатываний",
    "duration": "Продолжительность",
    "alarmCondition": "Условие тревоги",
    "notRelease": "Не опубликовано",
    "haveReleased": "Опубликовано",
    "soldOut": "Снято с публикации",
    "alarmName": "Название тревоги",
    "selectDevice": "Пожалуйста, выберите активное устройство",
    "conditionList": "Список условий",
    "and&or": "Пожалуйста, выберите И или ИЛИ",
    "attribute": "Свойство",
    "selectCondition": "Пожалуйста, выберите условие",
    "delete": "Удалить",
    "enterContent": "Пожалуйста, введите содержимое",
    "addCondition": "Добавить условие",
    "alarmLevel": "Уровень тревоги",
    "notificationChannel": "Канал уведомления",
    "advancedOptions": "Дополнительные параметры",
    "manuallyAlarm": "Ручное снятие тревоги",
    "selectManually": "Пожалуйста, выберите ручное снятие тревоги",
    "startTime": "Время начала",
    "endTime": "Время окончания",
    "effectivePeriod": "Период действия",
    "noTimeSelect": "Период времени не выбран",
    "experienceTime": "Испытать настраиваемое время (более гибкие уведомления)",
    "returnTime": "Вернуться к традиционному выбору времени",
    "support": "Поддерживается",
    "nonsupport": "Не поддерживается",
    "notificationPeriod": "Период уведомления",
    "general": "Обычный",
    "significance": "Важный",
    "seriousness": "Серьезный",
    "minute": "минута",
    "second": "секунда",
    "time": "раз",
    "alarmNameNot": "Название тревоги не может быть пустым",
    "sourceTypeNot": "Тип источника данных не может быть пустым",
    "sourceNot": "Источник устройства не может быть пустым",
    "triggerTypeNot": "Тип триггера не может быть пустым",
    "conditionsNot": "Список условий не может быть пустым",
    "severityNot": "Уровень тревоги не может быть пустым",
    "manuallyNot": "Выбор ручного снятия тревоги обязателен",
    "success": "Успешно",
    "fail": "Неудача",
    "and": "И",
    "or": "ИЛИ",
    "greaterThan": "Больше чем",
    "equalOrGreater": "Больше или равно",
    "lessThan": "Меньше чем",
    "lessEqual": "Меньше или равно",
    "equalTo": "Равно",
    "unequalTo": "Не равно",
    "selectActiveDevice": "Пожалуйста, выберите активное устройство"
  },
  "inform": {
    "warningMessage": "Информация о тревоге",
    "pending": "Ожидает обработки",
    "automaticResolution": "Автоматическое решение",
    "manualSolution": "Ручное решение"
  },
  "notification": {
    "notificationChannelName": "Название канала уведомлений",
    "notificationWay": "Способ уведомления",
    "sureDelete": "Вы уверены, что хотите удалить?",
    "emailEmpty": "Адрес электронной почты не может быть пустым",
    "emailFormat": "Неверный формат адреса электронной почты",
    "nameEmpty": "Название уведомления не может быть пустым",
    "typeEmpty": "Тип уведомления не может быть пустым",
    "updateSuccessfully": "Обновлено успешно",
    "createdSuccessfully": "Создано успешно",
    "email": "Электронная почта",
    "emailAddress": "Адрес электронной почты",
    "phoneMessage": "Номер телефона",
    "invalidPhoneMessage": "Недействительный номер телефона"
  },
  "profile": {
    "enterNickname": "Пожалуйста, введите никнейм",
    "enterEmail": "Пожалуйста, введите адрес электронной почты",
    "validEmail": "Пожалуйста, введите корректный адрес электронной почты",
    "enterNumber": "Пожалуйста, введите номер телефона",
    "enterValidNumber": "Пожалуйста, введите корректный номер телефона",
    "modifySuccessfully": "Успешно изменено",
    "failModify": "Ошибка при изменении",
    "enterOldPassword": "Пожалуйста, введите старый пароль",
    "enterNewPassword": "Пожалуйста, введите новый пароль",
    "characters": "Пароль должен содержать не менее 6 символов",
    "confirmNewPassword": "Пожалуйста, подтвердите новый пароль",
    "twoPasswordsDifferent": "Введённые пароли не совпадают",
    "passwordSuccessfully": "Пароль успешно изменён",
    "essentialInformation": "Основная информация",
    "failedPassword": "Ошибка изменения пароля",
    "nickname": "Ник пользователя",
    "phoneNumber": "Номер телефона пользователя",
    "userMailbox": "Электронная почта пользователя",
    "changePassword": "Изменить пароль",
    "oldPassword": "Старый пароль",
    "newPassword": "Новый пароль",
    "confirmNewPasswordLabel": "Подтвердите новый пароль",
    "editAvatar": "Редактировать аватар",
    "username": "Имя пользователя",
    "callPhoneNumber": "Номер телефона",
    "loginTime": "Время входа",
    "myAPP": "Мои приложения",
    "verificationCode": "Код подтверждения",
    "enterVerificationCode": "Пожалуйста, введите код подтверждения",
    "bindPhoneNumber": "Привязать номер телефона",
    "updatePhoneNumber": "Обновить номер телефона",
    "update": "Обновить",
    "close": "Закрыть",
    "open": "Включить",
    "applicationName": "Название приложения",
    "getCode": "Получить код",
    "key": "Ключ",
    "status": "Статус",
    "sureChange": "Вы уверены, что хотите изменить это?"
  },
  "message": {
    "messageTip": "Сообщения",
    "noNewsYet": "Нет новых сообщений",
    "markedRead": "Отмечено как прочитанное",
    "notificationMessage": "Уведомления",
    "allRead": "Прочитать все",
    "markRead": "Отметить как прочитанное",
    "read": "Прочитано"
  },
  "base": {
    "navigation": "Навигация",
    "own": "Личный кабинет",
    "help": "Нужна помощь?",
    "helpDesc": "Мы можем предложить вам следующую помощь.",
    "softwareSupport": "Техническая поддержка IoT",
    "hardwareSupport": "Техническая поддержка оборудования",
    "essentialInformation": "Важная информация"
  },
  "routesMenu": {
    "homePage": "Главная",
    "data": "Центр данных",
    "device": "Центр устройств",
    "alarm": "Центр тревог",
    "inform": "Уведомления о тревогах",
    "notification": "Каналы уведомлений",
    "arrange": "Управление устройствами",
    "me": "Личный кабинет",
    "message": "Центр сообщений"
  },
  "login": {
    "userTerms": "Пользовательские условия",
    "iAgree": "Я согласен",
    "captchaSuccess": "Проверка прошла успешно",
    "rememberMe": "Запомнить меня",
    "captchaFail": "Неверный код подтверждения",
    "signIn": "Войти",
    "welcome": "Добро пожаловать",
    "company": "Компания Ханьдань Юньнун Умные Сельскохозяйственные Технологии",
    "yantaiCompany": "Компания Ханьдань Янтай Импорт и Экспорт",
    'companyProfile':'<p class="text-white position-relative">\n' +
      '                  Мы предоставляем продукцию, охватывающую области солнечного света, воздуха, почвы и водной среды, используя технологии беспроводной связи и удобные мобильные приложения для обслуживания клиентов. Количество поставляемых датчиков достигает сотен тысяч, мы являемся известным поставщиком сенсорных продуктов и цифровых решений в отрасли.\n' +
      '                </p>\n' +
      '                <p class="text-white position-relative">\n' +
      '                  Компания придерживается культурных ценностей «Честность, Взаимопонимание, Инновации, Обмен» и готова вместе с клиентами по всей цепочке создания стоимости внести свой вклад в реализацию национальной концепции развития «Цифровой Китай» в новую эпоху, обеспечивая надежную сеть мониторинга и устойчивую защиту окружающей среды, на которой базируется существование человечества.！\n' +
      '                </p>',
    'yantaiCompanyProfile' : '<p class="text-white position-relative">\n' + 'Компания Ханьдань Янтай Импорт и Экспорт' + '</p>\n' +
      '<p class="text-white position-relative">\n' + 'Наши продукты охватывают области солнечного света, воздуха, почвы и водной среды. Используя технологии беспроводной связи и удобное мобильное управление, мы обслуживаем клиентов, предоставляя сотни тысяч видов датчиков. Мы являемся известным поставщиком датчиков и цифровых решений в отрасли.' + '</p>\n' +
      '<p class="text-white position-relative">\n' + 'Компания придерживается культурных ценностей «Честность, Интеграция, Инновации, Совместное использование» и готова вместе с клиентами по всей цепочке создавать ценность, внося свой вклад в реализацию концепции развития «Глобальная цифровизация» новой эпохи, обеспечивая надежную сеть мониторинга и устойчивую защиту окружающей среды, необходимой для существования человечества.' + '</p>\n'
  },
  "site": {
    'yantaiTitle': 'Яньтай',
    'primaryName': 'Облачноe поле',
    'name': 'Платформа Интернета вещей (IoT)'
  },
  navbar: {
    'businessCaseName': 'Коммерческие кейсы',
    'businessCaseUrl': 'http://nong-iot.cn/business-case.html',
    'businessConsultingName': 'Бизнес-консультации',
    'businessConsultingUrl': 'http://nong-iot.cn/consult.html',
    'aboutUsName': 'О нас',
    'aboutUsNameUrl': 'http://nong-iot.cn/about-us.html',
    'productCenterName': 'Центр продуктов',
    'productCenterNameUrl': 'http://nong-iot.cn/'
  },
  configurator: {
    'theme': 'Настройка темы',
    'themeOptions': 'Просмотрите поддерживаемые нами варианты тем.',
    'sidebarColors': 'Цвета боковой панели',
    'sidenavType': 'Левая навигационная панель',
    'sidenavDesc': 'Режим переключения поддерживает светлый и тёмный режимы',
    'white': 'Светлый',
    'dark': 'Тёмный',
    'navbarFixed': 'Фиксация панели навигации',
    'themeSwitching': 'Светлый / Тёмный',
    'quit': 'Выйти'
  },
  element: {
    "空气温度": "Температура воздуха",
    "空气湿度": "Влажность воздуха",
    "大气压强": "Атмосферное давление",
    "风速": "Скорость ветра",
    "风向": "Направление ветра",
    "降雨量": "Количество осадков",
    "蒸发量": "Испарение",
    "土壤温度": "Температура почвы",
    "土壤湿度": "Влажность почвы",
    "土壤EC": "EC почвы",
    "土壤EC2": "EC почвы 2",
    "土壤EC3": "EC почвы 3",
    "土壤PH": "pH почвы",
    "光照强度": "Интенсивность освещения",
    "光合有效": "Эффективная фотосинтезирующая радиация",
    "总辐射": "Общее излучение",
    "总辐射累积量": "Накопленное общее излучение",
    "水平辐射": "Горизонтальное излучение",
    "水平辐射累积量": "Накопленное горизонтальное излучение",
    "斜面辐射": "Наклонное излучение",
    "斜面辐射累积量": "Накопленное наклонное излучение",
    "散射辐射": "Рассеянное излучение",
    "散射辐射累积量": "Накопленное рассеянное излучение",
    "直接辐射": "Прямое излучение",
    "直接辐射累积量": "Накопленное прямое излучение",
    "紫外指数": "УФ-индекс",
    "紫外辐射": "Ультрафиолетовое излучение",
    "日照时数": "Продолжительность солнечного света",
    "噪声": "Шум",
    "PM2.5": "PM2.5",
    "PM10": "PM10",
    "CO2": "CO2",
    "SO2": "SO2",
    "CO": "CO",
    "O3": "O3",
    "H2S": "H2S",
    "NO2-1": "NO2-1",
    "NO2-2": "NO2-2",
    "叶面温度": "Температура листа",
    "叶面湿度": "Влажность листа",
    "组件温度": "Температура компонента",
    "露点温度": "Температура точки росы",
    "小时雨量": "Часовое количество осадков",
    "24小时雨量": "Количество осадков за 24 часа",
    "连续雨量": "Непрерывное количество осадков",
    "水温": "Температура воды",
    "水PH": "pH воды",
    "水EC": "EC воды",
    "溶氧": "Растворённый кислород",
    "浊度": "Мутность",
    "NH3": "Аммиак (NH3)",
    "暴晒温度": "Температура под прямыми солнечными лучами",
    "微气象风速": "Скорость ветра микро-климата",
    "微气象风向": "Направление ветра микро-климата",
    "设备电压": "Напряжение устройства",
    "设备电量": "Заряд устройства",
    "TSP(PM)100": "TSP (PM)100",
    "负氧离子": "Отрицательные ионы кислорода",
    "流速(多普勒)": "Скорость потока (доплер)",
    "液位(超声)": "Уровень жидкости (ультразвук)",
    "液位(压力)": "Уровень жидкости (давление)",
    "能见度": "Видимость",
    "路面状况路面温度": "Температура дорожного покрытия",
    "路面状况积水深度": "Глубина луж на дороге",
    "路面状况冰厚度": "Толщина льда на дороге",
    "路面状况雪厚度": "Толщина снега на дороге",
    "路面状况湿滑系数": "Коэффициент скользкости дороги",
    "路面状况路面状态": "Состояние дорожного покрытия",
    "GPS东西经": "GPS долгота восток-запад",
    "GPS经度": "GPS долгота",
    "GPS南北纬": "GPS широта север-юг",
    "GPS纬度": "GPS широта",
    "TVOC": "Общие летучие органические соединения (TVOC)",
    "雨雪报警": "Сигнализация дождя и снега",
    "电池电压": "Напряжение батареи",
    "太阳能电压": "Напряжение солнечной батареи",
    "信号强度": "Уровень сигнала",
    "果实膨大": "Рост плодов",
    "氨氮": "Аммонийный азот",
    "水膜厚度": "Толщина водной пленки",
    "土壤硬度": "Жёсткость почвы",
    "蒸腾量": "Транспирация",
    "EC": "EC",
    "前置冲洗时间": "Время предварительной промывки",
    "轮灌间隔": "Интервал кругового полива",
    "轮灌次数": "Количество циклов полива",
    "水肥机工作模式": "Режим работы водоудобрительной машины",
    "水肥机状态": "Состояние водоудобрительной машины",
    "水泵状态": "Состояние водяного насоса",
    "PH": "pH",
    "肥泵状态": "Состояние насоса удобрений",
    "目标EC": "Целевой EC",
    "目标PH": "Целевой pH",
    "后置冲洗时间": "Время последующей промывки",
    "主水源瞬时流量": "Мгновенный расход основного источника воды",
    "主水源累积流量": "Накопленный расход основного источника воды"
  }












}
